import {
  enum as zodEnum,
  number,
  object,
  type output,
  string,
} from 'zod';
import { awardTypes } from '../../common/types/award-types';
import { winnerRoles } from '../shared/winner-role-types';
import { isValidUrl } from '../../shared/functions';
import { validDocumentGroupTypeKeys } from '../program-document';

export const MAX_PROGRAM_DOCUMENT_DISPLAY_NAME_LENGTH = 50;
export const MAX_PROGRAM_DOCUMENT_DESCRIPTION_LENGTH = 200;
export const MAX_PROGRAM_DOCUMENT_URL_LENGTH = 512;

const fileLocationUrlSchema = string()
  .max(MAX_PROGRAM_DOCUMENT_URL_LENGTH, {
    error: `Use ${MAX_PROGRAM_DOCUMENT_URL_LENGTH} characters or fewer for the file location URL.`,
    abort: true,
  })
  .refine(isValidUrl, 'Enter a valid file location URL.')
  .optional();

export const programDocumentRequestSchema = object({
  programDocumentId: number().optional(),
  displayName: string().min(1, 'Enter a display name.').max(MAX_PROGRAM_DOCUMENT_DISPLAY_NAME_LENGTH, `Use ${MAX_PROGRAM_DOCUMENT_DISPLAY_NAME_LENGTH} characters or fewer for the display name.`),
  description: string().min(1, 'Enter a description.').max(MAX_PROGRAM_DOCUMENT_DESCRIPTION_LENGTH, `Use ${MAX_PROGRAM_DOCUMENT_DESCRIPTION_LENGTH} characters or fewer for the description.`),
  documentGroupTypeCode: zodEnum(validDocumentGroupTypeKeys, {
    error: (issue) => issue.input ? `Select one of these document types: ${validDocumentGroupTypeKeys.join(', ')}.` : 'Select a document type.',
  }),
  winnerRole: zodEnum(winnerRoles, { error: `Select one of these winner roles: ${winnerRoles.join(', ')}.` }).optional(),
  awardType: zodEnum(awardTypes, { error: `Select one of these award types: ${awardTypes.join(', ')}.` }).optional(),
  ordinal: number({ error: 'Enter an ordinal.' }).min(1, 'Enter an ordinal of 1 or more.'),
  fileLocationUrl: fileLocationUrlSchema,
});

export type ProgramDocumentRequest = output<typeof programDocumentRequestSchema>;
